export default __webpack_public_path__ + "static/media/ferry.26f9a92a.png";